import { render, staticRenderFns } from "./AccountBuyBlackList.vue?vue&type=template&id=52b7169a&"
import script from "./AccountBuyBlackList.vue?vue&type=script&lang=js&"
export * from "./AccountBuyBlackList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports